export const LOGIN_ERROR_CODES = {
    TELEGRAM_NOT_LINKED: 'TELEGRAM_NOT_LINKED',
};

export const LOGIN_ERROR_STORAGE_KEYS = {
    message: 'loginError',
    code: 'loginErrorCode',
    communityUrl: 'loginErrorCommunityUrl',
};
